import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toggleChangeConfiguration} from "../actions/service";
import FormHandler from "../shared/utils/FormHandler";
import FeatherIcon from "feather-icons-react";
import {useTranslation} from "react-i18next";
import {getMetaData, updateMetaData} from "../utils/mainServices";
import {toast} from "react-toastify";
import {toggleLoader} from "../shared/actions/setting";
import { validateChangeConfiguration } from "../utils/validation";
const ChangeConfiguration = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const {t} = useTranslation();
  const [formErr, setFormErr] = useState("");
  //const [metadata, setMetadata] = useState(null); // State to store metadata

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleOnBlur,
    initForm,
  } = FormHandler(changeConfiguration, validateChangeConfiguration);

  function changeConfiguration() {
    setIsLoading(true);
  }

  const isChangeConfigurationVisible = useSelector(
    (state) => state.serviceList.isChangeConfigurationVisible
  );

  const hideChangeConfiguration = () => {
    dispatch(toggleChangeConfiguration(false));
  };

  function resetForm() {
    hideChangeConfiguration();
    initForm({});
    setFormErr("");
  }

  useEffect(() => {
    if (!isChangeConfigurationVisible) return;

    let isCancelled = false;

    const fetchMetadata = async () => {
      dispatch(toggleLoader(true));
      try {
        const metadata = await getMetaData();
        if (isCancelled) return;
        if (metadata?.content?.configuration) {
          initForm({
            hosturl: metadata.content.configuration.configHost || "",
            androidversion: metadata.content.configuration.androidVersion || "",
            iosversion: metadata.content.configuration.iosVersion || "",
          });
        }
      } catch (error) {
        console.error("Error fetching metadata:", error);
      }
      dispatch(toggleLoader(false));
    };

    fetchMetadata();

    return () => {
      isCancelled = true;
    };
  }, [isChangeConfigurationVisible]);

  useEffect(() => {
    const updateMetadata = async () => {
      dispatch(toggleLoader(true));
      try {
        const metadata = {
          configuration: {
            configHost: values.hosturl,
            androidVersion: values.androidversion,
            iosVersion: values.iosversion,
          },
        };
        const response = await updateMetaData(metadata);
        resetForm();
        toast.success("Configuration changed successfully");
      } catch (error) {
        console.error("Error updating metadata:", error);
        toast.error("There is an error")
      } finally {
        setIsLoading(false); // Reset isLoading
        dispatch(toggleLoader(false));
      }
    };

    if (isLoading) {
      updateMetadata();
    }
  }, [isLoading]); // Dependency array ensures this runs when values change


  return (
    <div className={"sa-popup-bg " + (!isChangeConfigurationVisible && "hide")}>
      <div className="sa-popup">
        <form onSubmit={handleSubmit} className={"sa-modal-box-style"}>
          <div className="sa-popup-header">
            <span className={"sa-model-heading"}>Host Configuration</span>
            <div className="sa-popup-close-icon" onClick={resetForm}>
              <FeatherIcon className={"sa-modal-close-icon"} icon={"x"}/>
            </div>
          </div>
          <div className="sa-popup-content">
              <div className="col-md-6">
                <div className="form-group m-b-16">
                  <label htmlFor="hosturl">Host URL</label>
                  <input
                    type="text"
                    className={`form-control ${errors.hosturl && "warning-input"}`}
                    onBlur={handleOnBlur}
                    onChange={handleChange}
                    value={values.hosturl || ""}
                    name="hosturl"
                    id="hosturl"
                    placeholder="Enter Host URL"
                    pattern="^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
                    required
                  />
                  {errors.hosturl && <p className="warning-input-msg">{errors.hosturl}</p>}
                </div>
            </div>
              <div className="col-md-6">
                <div className="form-group m-b-16">
                  <label htmlFor="androidversion">Android version</label>
                  <input
                    type="text"
                    className={`form-control ${errors.password && "warning-input"}`}
                    onBlur={handleOnBlur}
                    onChange={handleChange}
                    value={values.androidversion || ""}
                    name="androidversion"
                    id="androidversion"
                    placeholder="Enter Android version"
                  />
                  {errors.androidversion && <p className="warning-input-msg">{errors.androidversion}</p>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group m-b-16">
                  <label htmlFor="iosversion">IOS Version</label>
                  <input
                    type="text"
                    className={`form-control ${errors.iosversion && "warning-input"}`}
                    onBlur={handleOnBlur}
                    onChange={handleChange}
                    value={values.iosversion || ""}
                    name="iosversion"
                    id="iosversion"
                    placeholder="Enter IOS version"
                  />
                  {errors.iosversion && (
                    <p className="warning-input-msg">{errors.iosversion}</p>
                  )}
                </div>
              </div>
          </div>
          {formErr && <div className={"login-warning-msg"}>{formErr}</div>}
          <div className="sa-popup-btn" style={{display: "flex", justifyContent: "flex-end"}}>
            <button className="sa-popup-secondary-btn-style">
              {t("button.CHANGE", {defaultValue: "Change"})}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeConfiguration;
